import React                                from 'react';
import { Observe }                          from 'rewire-core';
import { WithStyle, withStyles }            from 'rewire-ui';
import classNames                           from 'classnames';
import { Theme }                            from '@material-ui/core/styles';
import Typography                           from '@material-ui/core/Typography';
import OkIcon                               from '@material-ui/icons/CheckCircle';
import ErrorIcon                            from '@material-ui/icons/Cancel';
import {
  ITimecardTest,
  TimecardTestStatusType,
}                                           from '../DataTypes';
import { makeStyles }                       from '../utility/styles';
import RoutedEntityListCardView, {
  IRoutedEntityListCardViewProps,
  IItemRendererProps,
}                                           from '../ui/RoutedEntityListCardView';
import { TimecardTestListModel }            from './TimecardTestListModel';
// import timecardTestModel                    from './TimecardTestModel';


const timecardTestStatusIconStyles = (theme: Theme) => ({
  status: {
    fontSize: '1.8rem',
  },
  statusOk: {
    color: theme.palette.success.main,
  },
  statusError: {
    color: theme.palette.error.main,
  },
});

const useTimecardTestStatusIconStyles = makeStyles(timecardTestStatusIconStyles);

export const TimecardTestStatusIcon = (props: {status: TimecardTestStatusType, classes?: any}) => {
  const classes     = useTimecardTestStatusIconStyles(props);
  const StatusIcon  = props.status === 'ok' ? OkIcon : ErrorIcon;
  const statusClass = props.status === 'ok' ? classes.statusOk : classes.statusError;
  return (
    <StatusIcon className={classNames(classes.status, statusClass)} />
  );
};

const itemRendererStyles = (theme: Theme) => ({
  employeeName: {
    color: theme.palette.dialogPrimary.main,
    fontWeight: 'bold',
  },
  testName: {
    color: theme.palette.dialogPrimary.main,
  },
  effective: {
    color: theme.palette.dialogPrimary.main,
  },
});

const useItemRendererStyles = makeStyles(itemRendererStyles);

export const TimecardTestItemRenderer = ({entity, classes}: IItemRendererProps) => (
  <Observe render={() => {
    classes                                                   = useItemRendererStyles({classes});
    const {employeeName, testName, effective, ...restClasses} = classes;
    const test = entity as ITimecardTest;
    return (
      < >
        <div>
          <Typography variant='body2' className={employeeName}>
            {test.employee.name}
          </Typography>
          <Typography variant='caption' display='block' className={testName}>
            {test.name}
          </Typography>
          <Typography variant='caption' display='block' className={effective}>
            {`${test.effective.startAsString()} to ${test.effective.endAsString() || '-'}`}
          </Typography>
        </div>
        <TimecardTestStatusIcon status={test.status} classes={restClasses} />
      </>
    );
  }} />
);

const styles = (_theme: Theme) => ({
});

interface ITimecardTestListCardViewProps extends Omit<IRoutedEntityListCardViewProps, 'model' | 'entity'> {
  model:  TimecardTestListModel;
  entity: ITimecardTest;
}

type TimecardTestListCardViewProps = WithStyle<ReturnType<typeof styles>, ITimecardTestListCardViewProps>;

export class TimecardTestListCardView extends React.Component<TimecardTestListCardViewProps> {
  constructor(props: TimecardTestListCardViewProps) {
    super(props);
  }

  render() {
    const { classes, model, entity, itemRenderer, itemClasses } = this.props;
    const ItemRenderer                                          = itemRenderer || TimecardTestItemRenderer;

    return <Observe render={() => {
      // const view = timecardTestModel.view; // reload when view changes to update links.

      return (
        <RoutedEntityListCardView model={model} entity={entity} classes={classes} itemRenderer={ItemRenderer} itemClasses={itemClasses} />
      );
    }} />;
  }
}

export default withStyles(styles, TimecardTestListCardView);
